// import React, { useState } from "react";
import React from "react";
import COR from "../../PicesForPages/officermortgagePage.jpg";
import whatsappIcon from "../../PicesForPages/WhatsappIconWithLabel.png";
import { Link } from "react-router-dom";

import MortgageCalculator from "../CalculatorAndChart/mortgageCalculator";
import BlogPostInAPage from "../blogPages/BlogPagePosts/blogPostInAPage";
// import FreeQuoteForm from "../Form/FreeQuote";
import blankPhoto from "../../PicesForPages/blank.jpg";
import Staff_RameshNagarajan_2017892 from "../../PicesForPages/Staff_RameshNagarajan_NMLS_2017892.jpg";
import staff_SridharParepalli_1789686 from "../../PicesForPages/Staff_SridharParepalli_NMLS_1789686.jpg";
import staff_VisveshBalasubramanian_2629696 from "../../PicesForPages/staff_VisveshBalasubramanian_NMLS_2629696.jpg";
import staff_JegadheesanJayavel_2686128 from "../../PicesForPages/staff_JegadheesanJayavel.jpg";
import Staff_SreekanthReddyChalla_NMLS_2275417 from "../../PicesForPages/Staff_SreekanthReddyChalla_NMLS_2275417.jpg";
import staff_RajeshCheruku_NMLS_2658067 from "../../PicesForPages/staff_RajeshCheruku_NMLS_2658067.jpg";
import staff_SubbuKemisetti_NMLS_2699154 from "../../PicesForPages/staff_SubbuKemisetti_NMLS_2699154.jpg";
import Staff_SwathiSolipuram_NMLS_2575114 from "../../PicesForPages/Staff_SwathiSolipuram_NMLS_2575114.jpg.jpeg";
import Staff_JeromeMariarathinam_NMLS_2711299 from "../../PicesForPages/Staff_JeromeMariarathinam.jpeg";
import Staff_SurekhaRamanaiah_NMLS_2490122 from "../../PicesForPages/Staff_SurekhaRamanaiah_NMLS_2490122.jpeg";
import Staff_KarthikaThesingupandi_NMLS_2687553 from "../../PicesForPages/Staff_KarthikaThesingupandi_NMLS_2687553.jpeg";
import Staff_TanviAshishJadhav_NMLS_2690887 from "../../PicesForPages/Staff_TanviAshishJadhav_NMLS_2690887.jpeg";
import staff_DhumpaRaghuram_NMLS_2842662 from "../../PicesForPages/staff_DhumpaRaghuram_NMLS_2842662.jpg";

import { useParams } from "react-router-dom";
import ClientReviewRameshKNagarajan from "../Client_Review/clientReviewRameshKNagarajan";
import ClientReviewSridharParepalli from "../Client_Review/clientReviewSridharParepalli";
import ClientReviewVisveshBalasubramanian from "../Client_Review/clientReviewVisveshBalasubramanian";
import ClientReviewJegadheesanJayavel from "../Client_Review/clientReviewJegadheesanJayavel";

function TeamMemberFullDetails() {
  const { id } = useParams();

  // Initialize the state before any condition
  // const [isFreeQuoteVisible, setIsFreeQuoteVisible] = useState(false);

  const teamMembers = {
    "ramesh-nagarajan": {
      name: "Ramesh Nagarajan",
      role: "LO - FL, GA, NJ, NC, PA, SC, TX & VA",
      photo: Staff_RameshNagarajan_2017892,
      nmls: "2017892",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(925) 878-9829",
      // contactWork: "(925) 878-9829",
      contactMail: "Ramesh.nagarajan@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "sridhar-parepalli": {
      name: "Sridhar Parepalli",
      role: "Loan Originator - MD, NC, OR & SC",
      photo: staff_SridharParepalli_1789686,
      nmls: "1789686",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(980) 230-3225",
      // contactWork: "(980) 230-3225",
      contactMail: "sridhar.parepalli@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "visvesh-balasubramanian": {
      name: "Visvesh Balasubramanian",
      role: "Loan Originator - NC",
      photo: staff_VisveshBalasubramanian_2629696,
      nmls: "2629696",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(919) 219-4002",
      // contactWork: "(919) 219-4002",
      contactMail: "visveshb@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "jegadheesan-jayavel": {
      name: "Jegadheesan Jayavel",
      // role: "MLO - CO, FL, GA, MD, NC, OR, PA, TX, VA & WA",
      role: "MLO - AL, CO, FL, GA, MD, NC, OR, PA, TX & VA",
      photo: staff_JegadheesanJayavel_2686128,
      nmls: "2686128",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(919) 699-6379",
      // contactWork: "(919) 699-6379",
      contactMail: "Jegadheesan@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "sreekanth-reddy-challa": {
      name: "Sreekanth Reddy Challa",
      role: "Loan Originator - VA",
      photo: Staff_SreekanthReddyChalla_NMLS_2275417,
      nmls: "2275417",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(732) 604-3966",
      // contactWork: "(732) 604-3966",
      contactMail: "sreekanth@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "rajesh-cheruku": {
      name: "Rajesh Cheruku",
      role: "Loan Originator - VA",
      photo: staff_RajeshCheruku_NMLS_2658067,
      nmls: "2649552",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(845) 559-3643",
      // contactWork: "(845) 559-3643",
      contactMail: "rajesh.cheruku@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "subbu-kemisetti": {
      name: "Subbu Kemisetti",
      role: "Loan Originator - VA",
      photo: staff_SubbuKemisetti_NMLS_2699154,
      nmls: "2699154",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(703) 599-7281",
      // contactWork: "",
      contactMail: "subbu.kemisetti@primehomemtg.com",
      yourService: `About Me:
      A Dedicated Mortgage Loan Officer committed to helping individuals and families achieve the dream of homeownership with confidence and clarity. Whether you're buying your first home, refinancing, or exploring your investment property options, my goal is to provide you with the best service in the industry—tailored to your unique financial situation and goals.
      What sets me apart is my personal approach, transparent communication, and deep commitment to finding the right loan solutions for every client. I work with a wide range of loan products—from conventional and FHA to VA and jumbo loans—and I'm here to guide you through each step of the process with clarity and care.

      What I Offer:
      Personalized loan solutions tailored to your needs
      Competitive rates and flexible options
      Clear, timely communication throughout the process
      Fast, efficient pre-approvals
      Support for first-time homebuyers, seasoned investors, and everyone in between
      My mission is simple: to make financing your home as smooth and stress-free as possible. I'm not just here to get you a loan—I'm here to build a long-term relationship based on trust, reliability, and results.
      Let's connect and make your home financing journey a successful story and home ownership a reality.`,
    },
    "naga-bachu": {
      name: "Naga Prathusha Bachu",
      // role: "Loan Originator - GA, NC, PA, TX & VA",
      role: "Loan Originator - GA, NC, PA & VA",
      photo: blankPhoto,
      nmls: "2028051",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(408) 718-1614",
      // contactWork: "",
      contactMail: "naga.bachu@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "swathi-solipuram": {
      name: "Mrs Swathi Solipuram",
      role: "Loan Originator - TX",
      photo: Staff_SwathiSolipuram_NMLS_2575114,
      nmls: "2575114",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(651) 424-7110",
      // contactWork: "",
      contactMail: "swathi.solipuram@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "jerome-mariarathinam": {
      name: "Jerome Mariarathinam",
      role: "Loan Originator - VA",
      photo: Staff_JeromeMariarathinam_NMLS_2711299,
      nmls: "2711299",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(703) 531-9563",
      // contactWork: "",
      contactMail: "jerome.mariarathinam@primehomemtg.com",
      yourService: `Meet Jerome Mariarathinam\n\nI’m a licensed Mortgage Loan Originator serving homebuyers and homeowners across Virginia. My goal is simple: make the financing process clear, strategic, and stress-free.\n\nI work with first-time buyers, self-employed clients, move-up buyers, and investors to structure loan solutions that fit their long-term financial goals — not just the immediate purchase.\n\nMy approach is proactive and transparent. I take time to review your full financial picture, explain your options in simple terms, and guide you from pre-approval through closing with consistent communication.\n\nWhether you’re buying, refinancing, or exploring your home equity options, I’m here to help you make confident, informed decisions.`,
    },
    "ashwin-musuku": {
      name: "Ashwin Musuku",
      role: "Loan Originator - GA & NC",
      photo: blankPhoto,
      nmls: "2692292",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(571) 235-4401",
      // contactWork: "",
      contactMail: "ashwin.musuku@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "gokul-gopalasamy": {
      name: "Gokul Gopalasamy",
      role: "Loan Originator - AL, OR, TX & WA",
      photo: blankPhoto,
      nmls: "1820273",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(503) 933-3547",
      // contactWork: "",
      contactMail: "gokul.gopalasamy@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "surekha-ramanaiah": {
      name: "Surekha Ramanaiah",
      role: "Loan Originator - OR",
      photo: Staff_SurekhaRamanaiah_NMLS_2490122,
      nmls: "2490122",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(971) 506-1437",
      // contactWork: "",
      contactMail: "surekha.ramanaiah@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "pooja-mahanthesh": {
      name: "Pooja Mahanthesh",
      role: "Loan Originator - TX",
      photo: blankPhoto,
      nmls: "2690514",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(469) 629-9491",
      // contactWork: "",
      contactMail: "pooja.mahanthesh@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "tanvi-ashish-jadhav": {
      name: "Tanvi Ashish Jadhav",
      role: "Loan Originator - OR & TX",
      photo: Staff_TanviAshishJadhav_NMLS_2690887,
      nmls: "2690887",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(404) 205-3089",
      // contactWork: "",
      contactMail: "tanvi.jadhav@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "shrinivashan-shanmuogam": {
      name: "Shrinivashan Shanmuogam",
      role: "Loan Originator - OR",
      photo: blankPhoto,
      nmls: "2659119",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(510) 396-2794",
      // contactWork: "",
      contactMail: "shrinivashan.shanmuogam@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "srinivas-kunchala": {
      name: "Srinivas Kunchala",
      role: "Loan Originator - VA",
      photo: blankPhoto,
      nmls: "2818273",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(516) 606-1315",
      // contactWork: "",
      contactMail: "Srinivas.kunchala@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "karthika-thesingupandi": {
      name: "Karthika Thesingupandi",
      role: "Loan Originator - NC",
      photo: Staff_KarthikaThesingupandi_NMLS_2687553,
      nmls: "2687553",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(603) 343-7233",
      // contactWork: "",
      contactMail: "karthika.thesingu@primehomemtg.com",
      yourService: `I’m Karthika, a Mortgage Loan Originator at Prime Home Mortgage. I’m passionate about helping homebuyers and homeowners navigate the mortgage process with confidence. My goal is to provide personalized guidance, clear communication, and reliable service every step of the way. Whether you’re purchasing your first home or refinancing, I’m committed to making your home financing experience as smooth and stress-free as possible.`,
    },
    "srinivasa-rao-yarlagadda": {
      name: "Srinivasa Rao Yarlagadda",
      role: "Loan Originator - CO",
      photo: blankPhoto,
      nmls: "2027043",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(720) 222-2250",
      // contactWork: "",
      contactMail: "Srini.Yarlagadda@primehomemtg.com",
      yourService: `Whether you're buying, selling, refinancing, or building your dream home, you have a lot riding on your loan specialist. Since market conditions and mortgage programs change frequently, you need to make sure you're dealing with a top professional who is able to give you quick and accurate financial advice. As an experienced loan officer I have the knowledge and expertise you need to explore the many financing options available.\n\nEnsuring that you make the right choice for you and your family is my ultimate goal. And I am committed to providing my customers with mortgage services that exceed their expectations. I hope you'll browse my website, check out the different loan programs I have available, use my decision-making tools and calculators, and use our secure online application to get started.\n\nAfter you've applied, I'll call you to discuss the details of your loan, or you may choose to set up an appointment with me using my online form. As always, you may contact me anytime by phone, fax or email for personalized service and expert advice.\n\nI look forward to working with you.`,
    },
    "raghuram-dhumpa": {
      name: "Raghuram Dhumpa",
      role: "Loan Originator - FL, GA & TX",
      photo: staff_DhumpaRaghuram_NMLS_2842662,
      nmls: "2842662",
      address: "2120 Crown Centre Dr, \nSuite 400A, Charlotte, NC \n28227.",
      contactPhone: "(850) 980-7418",
      // contactWork: "",
      contactMail: "raghu.dhumpa@primehomemtg.com",
      yourService: `Buying a home is one of the biggest financial decisions you will make, and having the right mortgage professional can make the process easier and more rewarding. Whether you are a first-time homebuyer, purchasing your next home, refinancing, or exploring investment opportunities, I am here to help you navigate your options with confidence. As a dedicated Loan Originator, my focus is providing personalized guidance, clear communication, and solutions tailored to your unique financial goals. I work with a variety of loan programs and take the time to understand your needs so we can find the right financing strategy for you. My commitment is to make the mortgage process simple, transparent, and stress-free. From your initial consultation through closing, I will be by your side to answer questions, explain your options, and help you make informed decisions. Explore available loan programs, use our mortgage tools and calculators, or start your secure online application today. I look forward to helping you achieve your homeownership goals and providing a smooth, personalized mortgage experience.`,
    },
  };

  const member = teamMembers[id];

  if (!member) {
    return <div>Team Member not found</div>;
  }

  // // Function to hide the FreeQuoteFormParent
  // const hideFreeQuoteForm = () => {
  //   setIsFreeQuoteVisible(false);
  // };

  // // Function to handle clicks outside the FreeQuoteBox
  // const handleOutsideClick = (event) => {
  //   if (event.target.classList.contains("FreeQuoteFormParent")) {
  //     hideFreeQuoteForm();
  //   }
  // };

  return (
    <div className="purchaseParent ourTeamMemberParent">
      <div className="ourTeamMemberTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={COR}
          alt="CORImage"
          className="ourTeamMemberTopBGImage"
        />
        <div className="ourTeamMemberTopBox">
          <span className="ourTeamMemberTopLeftSide">
            <span className="ourTeamMemberTopLeftSideSpanImage">
              <img
                fetchPriority="high"
                loading="eager"
                src={member.photo}
                alt={member.name}
                className="ourTeamMemberTopStaffImage"
              />
            </span>
            <span>
              <span className="ourTeamMemberTopLeftSideName">
                {member.name}
              </span>
              <br />
              <span className="ourTeamMemberTopLeftSideRole">
                {member.role}
              </span>
              <br />
              <span className="ourTeamMemberTopLeftSideNMLS">
                NMLS#: {member.nmls}
              </span>
              <br />
            </span>
          </span>
          <span className="ourTeamMemberTopRightSide">
            <span>
              <b>Address:</b>
              <br />
              {member.address.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </span>
            <br />
            <span>
              <b>Contact:</b>
              <br />
              <i class="ri-phone-fill"></i> {member.contactPhone}
              <br />
              {/* <i class="ri-smartphone-line"></i> {member.contactWork}
              <br /> */}
              <i class="ri-mail-send-fill"></i> {member.contactMail}
              <br />
            </span>
          </span>
        </div>
      </div>
      <div className="purchaseBottomParent ourTeamMemberBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <div className="purchaseBottomLeftButton">
              {/* <span className="purchaseBottomLeftButtonLink">Apply</span> */}
              <Link
                to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                className="purchaseBottomLeftButtonLink"
              >
                APPLY!
              </Link>
              <Link
                to="/loan-application"
                className="purchaseBottomLeftButtonLink00"
              >
                Free Quote
              </Link>
              {/* <span
                className="purchaseBottomLeftButtonLink00"
                onClick={(e) => {
                  e.preventDefault();
                  setIsFreeQuoteVisible(true);
                }}
              >
                Free Quote
              </span> */}
              {/* {id === "ramesh-nagarajan" && (
                <Link
                  to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/rameshnagarajan"
                  className="purchaseBottomLeftButtonLink00"
                >
                  Free Quote
                </Link>
              )}
              {id === "sridhar-parepalli" && (
                <Link
                  to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/sridharParepalli"
                  className="purchaseBottomLeftButtonLink00"
                >
                  Free Quote
                </Link>
              )}
              {id === "visvesh-balasubramanian" && (
                <Link
                  to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/visveshBalasubramanian"
                  className="purchaseBottomLeftButtonLink00"
                >
                  Free Quote
                </Link>
              )}
              {id === "jegadheesan-jayavel" && (
                <Link
                  to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/jegadheesanJayavel"
                  className="purchaseBottomLeftButtonLink00"
                >
                  Free Quote
                </Link>
              )} */}
            </div>

            <span className="purchaseBottomLeftHeader">At Your Service</span>

            <span className="purchaseBottomLeftContent">
              {member.yourService.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </span>
          </div>
        </div>
      </div>
      {id === "ramesh-nagarajan" && <ClientReviewRameshKNagarajan />}
      {id === "sridhar-parepalli" && <ClientReviewSridharParepalli />}
      {id === "visvesh-balasubramanian" && (
        <ClientReviewVisveshBalasubramanian />
      )}
      {id === "jegadheesan-jayavel" && <ClientReviewJegadheesanJayavel />}
      <MortgageCalculator />
      <BlogPostInAPage />
      <div className="addressBoxParent">
        <div className="addressBox">
          <div className="addressHeading">
            The Prime Home Mortgage, INC Address
          </div>
          <div className="addressMapDetails">
            {/* <iframe
              title="Prime Home Mortgage, INC Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3255.399256645242!2d-80.77742482422828!3d35.32090577270577!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88541dc848bbd15b%3A0x2b6ff7553848568!2s1914%20J%20N%20Pease%20Pl%2C%20Charlotte%2C%20NC%2028262%2C%20USA!5e0!3m2!1sen!2sin!4v1732532106241!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe> */}
            <iframe
              title="Prime Home Mortgage, INC Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3262.4770319747704!2d-80.73613332510303!3d35.14472205926093!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88542142a401b723%3A0x21cdbdb0d8c9e57f!2s2120%20Crown%20Centre%20Dr%20%23400a%2C%20Charlotte%2C%20NC%2028227%2C%20USA!5e0!3m2!1sen!2sin!4v1737014268233!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
      {/* {isFreeQuoteVisible && (
        <div className="FreeQuoteFormParent" onClick={handleOutsideClick}>
          <div className="FreeQuoteFormBox">
            <FreeQuoteForm officerName={`${member.name} ${member.nmls}`} />
            <span
              className="FreeQuoteFormCloseButton"
              onClick={hideFreeQuoteForm}
            >
              <span>X</span>
            </span>
          </div>
        </div>
      )} */}
      <div className="WhatsApp WhatsAppTeam">
        {id === "ramesh-nagarajan" && (
          <a
            href="https://wa.link/138iv1"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatsappIcon}
              alt="whatsappIcon"
              className="whatsappIcon"
            />
          </a>
        )}
        {id === "sridhar-parepalli" && (
          <a
            href="https://wa.link/16qh0h"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatsappIcon}
              alt="whatsappIcon"
              className="whatsappIcon"
            />
          </a>
        )}

        {id === "visvesh-balasubramanian" && (
          <a
            href="https://wa.link/51bar9"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatsappIcon}
              alt="whatsappIcon"
              className="whatsappIcon"
            />
          </a>
        )}
        {id === "jegadheesan-jayavel" && (
          <a
            href="https://wa.link/r7n7kq"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatsappIcon}
              alt="whatsappIcon"
              className="whatsappIcon"
            />
          </a>
        )}
        {id === "sreekanth-reddy-challa" && (
          <a
            href="https://wa.link/5hd6dc"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatsappIcon}
              alt="whatsappIcon"
              className="whatsappIcon"
            />
          </a>
        )}
        {id === "rajesh-cheruku" && (
          <a
            href="https://wa.link/wrq1ss"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatsappIcon}
              alt="whatsappIcon"
              className="whatsappIcon"
            />
          </a>
        )}

        {id === "subbu-kemisetti" && (
          <a
            href="https://wa.link/71qfa7"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatsappIcon}
              alt="whatsappIcon"
              className="whatsappIcon"
            />
          </a>
        )}
        {id === "naga-bachu" && (
          <a
            href="https://wa.link/mrn2hg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatsappIcon}
              alt="whatsappIcon"
              className="whatsappIcon"
            />
          </a>
        )}
        {id === "swathi-solipuram" && (
          <a
            href="https://wa.link/1xcm5o"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatsappIcon}
              alt="whatsappIcon"
              className="whatsappIcon"
            />
          </a>
        )}
        {id === "jerome-mariarathinam" && (
          <a
            href="https://wa.link/iuumuf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatsappIcon}
              alt="whatsappIcon"
              className="whatsappIcon"
            />
          </a>
        )}
      </div>
    </div>
  );
}

export default TeamMemberFullDetails;
